import React from "react";
import { useTranslation } from "react-i18next";
import "./home.css";
import "./weather.css";

export default function Weather() {
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <h1 className="page-title">{t("weather.title")}</h1>

      <h2 className="page-subtitle">{t("weather.type1")}</h2>

      <p className="page-text">{t("weather.redrainstorm")}</p>
      <ul className="page-list">
        <li>{t("weather.redrainstorm-body")}</li>
      </ul>

      <p className="page-text">{t("weather.blackrainstorm")}</p>
      <ul className="page-list">
        <li>{t("weather.blackrainstorm-body1")}</li>
        {/* <li>{t("weather.blackrainstorm-body2")}</li> */}
        <li>{t("weather.blackrainstorm-body3")}</li>
        <li>{t("weather.blackrainstorm-body4")}</li>
      </ul>

      <ul className="page-list">
        <li>{t("weather.reschedule")}</li>
      </ul>

      <br />

      <h2 className="page-subtitle">{t("weather.type2")}</h2>
      <p className="page-text">{t("weather.typhoon3")}</p>
      <ul className="page-list">
        <li>{t("weather.typhoon3-body")}</li>
      </ul>

      <p className="page-text">{t("weather.typhoon")}</p>
      <ul className="page-list">
        <li>{t("weather.typhoon-body1")}</li>
        <li>{t("weather.typhoon-body2")}</li>
         <li>{t("weather.typhoon-body3")}</li>
          {/* <li>{t("weather.typhoon-body4")}</li> */}
      </ul>

      <ul className="page-list">
        <li>{t("weather.reschedule")}</li>
      </ul>

      <p className="page-text">{t("weather.contact-thanks")}</p>
    </div>
  );
}
